import { interval } from 'rxjs';
import { isPlainObject } from 'is-plain-object';

import request from '@utils/axiosWrapper';

const POLLING_INTERVAL = 4 * 60 * 1000;

/** 自动接单门店列表轮询 */
const init = () => {
    interval(POLLING_INTERVAL).subscribe(() => {
        request
            .get<string | null | undefined>(
                '/v2/shop/systemSettings/r/getPcAutoAcceptWmPoiIdList',
                {
                    params: {
                        jsVersion: window.STATIC_ASSET_VERSION,
                    },
                },
            )
            .then(
                res => {
                    if (res !== null && res !== undefined) {
                        // eslint-disable-next-line waimaie/no-direct-access-localstorage
                        localStorage.setItem('autoAcceptWmPoiList', res);
                    }
                },
                error => {
                    if (!isPlainObject(error)) {
                        throw Error(error.message);
                    }
                },
            );
    });
};

export default { init };
